import { toast } from "react-toastify";
import { axiosAction } from "./service";
import { getCookie } from "./cookies";

class LmsService {
    PIAP_API_URL = process.env.REACT_APP_API_BASE_URL;

    getCourses = async () => {
        const courseURL = `${this.PIAP_API_URL}/lms/get-courses`;
        const token = getCookie("piap_jwt_token");

        const apiInfo = {
            url: courseURL,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };

        try {
            const { data } = await axiosAction(apiInfo);

            if (data.length > 0) {
                return data;
            } else {
                return toast.error("No course found!!!");
            }
        } catch (error) {
            return toast.error(error.message);
        }
    };
}

export default new LmsService();
